import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

// BASE_URL é o basePath do tenant (mesma origem): as chamadas passam
// pelo proxy do BFF, que injeta a autenticação da sessão (cookie).
const $http = axios.create({
  baseURL: globalThis.Smart.env.BASE_URL,
  timeout: 90 * 1000,
});

Vue.use(VueAxios, $http);

const $axios = axios.create({
  timeout: 10 * 1000,
});

globalThis.$axios = $axios;

const axiosPlugin = {
  install(VueInstance) {
    VueInstance.prototype.$axios = $axios;
  },
};

Vue.use(axiosPlugin);

export default $http;
